import { useSearchParams } from 'react-router-dom'
import { CategoryBreakdownTab } from '@/components/categories/CategoryBreakdownTab'
import { ManageCategoriesTab } from '@/components/categories/ManageCategoriesTab'
import { TabButton } from '@/components/ui/tab-button'

type Tab = 'breakdown' | 'manage'

export default function CategoriesPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab: Tab = searchParams.get('tab') === 'manage' ? 'manage' : 'breakdown'

  function selectTab(next: Tab) {
    setSearchParams(next === 'manage' ? { tab: 'manage' } : {}, { replace: true })
  }

  return (
    <div className="flex flex-col gap-5 p-6 md:p-10">
      <header>
        <h2 className="font-serif text-[32px] font-bold leading-tight text-[var(--fl-heading)] md:text-[40px]">
          Categories
        </h2>
      </header>

      <div
        role="tablist"
        aria-label="Categories view"
        className="flex gap-1 border-b border-[var(--fl-border)]"
      >
        <TabButton active={tab === 'breakdown'} onClick={() => selectTab('breakdown')}>
          Breakdown
        </TabButton>
        <TabButton active={tab === 'manage'} onClick={() => selectTab('manage')}>
          Manage
        </TabButton>
      </div>

      {tab === 'manage' ? <ManageCategoriesTab /> : <CategoryBreakdownTab />}
    </div>
  )
}
